import React, {useEffect, useState} from "react";
import Button from '../common/Button';

const ListItemTest = props => {
    const {test, actionOnClick} = props;

    return (
        <tr>
            <td>{test.name}
                {test.exam &&
                    <>- exam</>
                }
            </td>
            <td>{test.questionCount}</td>
            <td>{test.ownedBy}</td>
            <td>
                {test.started &&
                    <>Yes</>
                }
                {!test.started &&
                    <>No</>
                }
            </td>
            <td>
                <Button onClick={actionOnClick} disabled={test.questionCount == 0}>Assign</Button>
            </td>
        </tr>
    )
}

export default ListItemTest;